<template>
  <!-- 个人中心 -->
  <div class="center">
    <!-- title -->
    <headers :params="hraderP" :user="user"></headers>
    <!-- 个人用户 -->
    <div class="user-list">
      <div class="user-item">
        <p class="user-name">我的服务</p>
        <div class="list">
          <div class="list-item" @click="enter('case')">
            <img src="../../assets/icon/case.png" class="list-img">
            <p class="list-case">我的方案</p>
          </div>
          <div class="list-item" @click="enter('shou')">
            <img src="../../assets/icon/shou.png" class="list-img">
            <p class="list-case">收藏方案</p>
          </div>
          <div class="list-item" @click="enter('need')">
            <img src="../../assets/icon/need.png" class="list-img">
            <p class="list-case">我的需求</p>
          </div>
        </div>
      </div>
      <!-- 设计师用户 -->
      <div class="user-item" v-if="exist">
        <p class="user-name">设计师</p>
        <div class="list">
          <div class="list-item" @click="enters('record')">
            <img src="../../assets/icon/record.png" class="list-img">
            <p class="list-case">报价记录</p>
            <a class="num">{{recordTotal}}</a>
          </div>
          <div class="list-item"  @click="enter('design')">
            <img src="../../assets/icon/design.png" class="list-img">
            <p class="list-case">设计任务</p>
            <a class="num">{{recordTotals}}</a>
          </div>
        </div>
      </div>
      <!-- 我的消息 -->
      <div class="user-item" style="padding-bottom: 12px;">
        <div class="notice"  @click="enter('notice')">
          <div class="notice-left">
            <p class="user-name" style="padding-bottom: 0px;">我的消息</p>
            <a class="notice-num">{{noticeList}}</a>
          </div>
          <div class="botice-right">
            <van-icon name="arrow" size="20" color="#999" />
          </div>
        </div>
      </div>
      <div class="excit">
        <button type="button" @click="exists()">退出登录</button>
      </div>
    </div>
  </div>
</template>

<script>
  import headers from '@/components/headerCenter'
  import { getUser } from '@/api/user/user'
  import { setCookie, getCookie, removeCookie } from '@/utils/cookies'
  import { getDesignList,getDesigntask,isDesginer } from '@/api/designer/designer'
  import { unnoticeList } from '@/api/notice/notice'
  import { Dialog } from 'vant'
  export default {
    components: {
      headers
    },
    data() {
      return{
        hraderP: {
          title: '个人中心',
          lefticon: true
        },
        userId:0,
        user:[],
        listQuery:{
          pageNum: 1,
          pageSize: 10,
          designerId:'',
          requireId:'',
          status:0,//报价状态 0-待报价 1-已报价 2-已拒绝 3-已过期
        },
        listQuerys:{
          pageNum: 1,
          pageSize: 10,
          userId:'',
          status:1,//任务状态 1-待接单；2-设计中；3-待审核；4-待验收；5-已完成；6-已拒绝；-1-审核不通过,不传-全部
        },
        recordTotal:'',
        recordTotals:'',
        noticeList:'',
        exist:false
      }
    },
    created() {
      this.userId = getCookie('accountId')
      if ($HMD$.rNavigator && $HMD$.rNavigator !== 'msite') {
        let _this = this
        $HMD$.GetLogin(function (data) {
          if (data.AccountId) {
            console.log(data.AccountId,'data.AccountId');
            _this.userId = data.AccountId
          } else {
            toLogin()
          }
        })
      }
      this.listQuerys.userId = getCookie('accountId')
      this.getUserInfo();
      this.getData();
      this.getDatas();
      this.isDesginer();
      this.getUnread();
    },
    mounted: function(){
        //和app发消息去除分享
        if ($HMD$.rNavigator === 'ios' || $HMD$.rNavigator === 'android') {
            // eslint-disable-next-line no-undef
            $HMD$.M.sendApp({
              name:'showShare',
              value: 0
            })
        }
    },
    methods:{
      getData(){
         getDesignList(this.listQuery).then(result => {
            this.recordTotal = result.data.data.total
         })
      },
      getDatas(){
         getDesigntask(this.listQuerys).then(result => {
            this.recordTotals = result.data.data.total
         })
      },
      isDesginer(){
        let param ={
          userId:getCookie('accountId')
        }
        isDesginer(param).then(res => {
          this.exist = res.data.data.exist
        })
      },
      getUnread(){
        let param = {
          toUser: getCookie('accountId'),
          pageSize: 10,
          pageNum: 1,
          readed: 0
        }
        unnoticeList(param).then(result => {
          this.noticeList = result.data.data.total
        })
      },
      getUserInfo(){
        if (this.userId) {
          getUser(this.userId).then(result => {
            if (result.status === 200 && result.data && result.data.respCode === '0000') {
              console.log( result.data.data);
              this.user = result.data.data
            }
          })
        }
      },
      enters(){
         this.$router.push(`/designer/quotation.html`)
      },
      // 退出登录
      exists(){
        Dialog.confirm({
          title: '',
          message: '确定退出登录？'
        }).then(() => {
          $HMD$.Cookie({
            type: "del",
            name: "ticket"
          });
          $HMD$.Cookie({
            type: "del",
            name: "accountId"
          });
          $HMD$.Cookie({
            type: "del",
            name: "AccountId"
          });
          removeCookie('ticket')
          removeCookie('accountId')
          removeCookie('AccountId')
          this.$router.push(`/index.html`)
        }).catch(() => {
          // 取消
        })
      },
      enter(e){
        console.log(e);
        switch (e) {
           case 'case':
            this.$router.push(`/solutionBuy.html?source=solution`)
            break
          case 'shou':
             this.$router.push(`/solutionBuy.html?tab=shou&source=solution`)
             // this.$router.push(`/solutionBuy.html`)
            break
          case 'need':
              this.$router.push(`/userPerson/userPerson.html`)
            break
          case 'notice':
              this.$router.push(`/notice/list.html`)
            break
          case 'record':
              this.$router.push(`/designer/quotation.html`)
          case 'design':
              this.$router.push(`/designer/quotationText.html`)
        }
      }
    }
  }

</script>

<style lang="scss" scoped>
  .center{
    background: #F4F6F9;
    .user-list{
      padding: 0 16px;
      margin-top: -10px;
      .user-item{
        background: #fff;
        border-radius: 4px;
        padding: 12px 12px 24px 12px;
        margin-bottom: 16px;
        .user-name{
          font-size: 16px;
          font-weight: 600;
          padding-bottom: 24px;
        }
        .list{
          display: flex;
          align-items: center;
          text-align: center;
          .list-item{
            margin-right: 30px;
            position: relative;
            .list-img{
              width: auto;
              height: 29px;
            }
            .list-case{
              font-size: 12px;
              font-weight: bold;
            }
            .num{
              position: absolute;
              top:-10px;
              right: 0;
              display: inline-block;
              width: 16px;
              height: 16px;
              line-height: 16px;
              background: #2F7BFF;
              border-radius: 50%;
              color: #fff;
              font-size: 9px;
            }
          }

        }
      }
      .notice{
        display: flex;
        justify-content: space-between;
        .notice-left{
          display: flex;
          .notice-num{
            margin-top: 4px;
            margin-left: 4px;
            display: inline-block;
            display: inline-block;
            width: 16px;
            height: 16px;
            line-height: 16px;
            background: #2F7BFF;
            border-radius: 50%;
            color: #fff;
            font-size: 9px;
            text-align: center;
          }
        }
      }
    }
    .excit{
      position: fixed;
      width: 100%;
      left: 0;
      bottom: 20px;
      button{
        width: 90%;
        margin-left: 5%;
        height: 44px;
        background: #FFFFFF;
        border-radius: 4px;
        border: none;
        font-weight: bold;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/personal/center.vue